// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.degree-card {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.card-title {
  font-family: "Google Sans Medium";
  font-size: 23px;
  margin-left: 10px;
}

.card-subtitle {
  font-family: "Google Sans Medium";
  font-size: 18px;
  margin-top: 7px;
  margin-bottom: 5px;
  margin-left: 10px;
}

.body-header {
  max-width: inherit;
  display: flex;
  border-radius: 7px 7px 0px 0px;
  padding: 10px;
}

.body-header-title {
  align-items: flex-start;
  width: 80%;
}

.body-header-duration {
  width: 20%;
}
.duration {
  font-family: "Google Sans Regular";
  font-size: 16px;
  padding-right: 10px;
  float: right;
}

.body-content {
  max-width: inherit;
  border-radius: 0px 0px 7px 7px;
  padding: 5px;
  justify-content: center;
  align-items: center;
}

.content-list {
  padding-left: 10px;
  padding-right: 10px;
  font-family: "Google Sans Regular";
}

@media (max-width: 768px) {
  .degree-card {
    flex-direction: column;
  }

  .body-header {
    flex-direction: column;
  }

  .body-header-title {
    width: 100%;
  }

  .body-header-duration {
    padding: 0;
    margin: 0;
    width: 100%;
  }

  .duration {
    padding: 0px;
    margin: 0px;
    float: left;
  }

  .card-title {
    font-size: 20px;
  }

  .card-subtitle {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/degreeCard/DegreeCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".degree-card {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n}\n\n.card-title {\n  font-family: \"Google Sans Medium\";\n  font-size: 23px;\n  margin-left: 10px;\n}\n\n.card-subtitle {\n  font-family: \"Google Sans Medium\";\n  font-size: 18px;\n  margin-top: 7px;\n  margin-bottom: 5px;\n  margin-left: 10px;\n}\n\n.body-header {\n  max-width: inherit;\n  display: flex;\n  border-radius: 7px 7px 0px 0px;\n  padding: 10px;\n}\n\n.body-header-title {\n  align-items: flex-start;\n  width: 80%;\n}\n\n.body-header-duration {\n  width: 20%;\n}\n.duration {\n  font-family: \"Google Sans Regular\";\n  font-size: 16px;\n  padding-right: 10px;\n  float: right;\n}\n\n.body-content {\n  max-width: inherit;\n  border-radius: 0px 0px 7px 7px;\n  padding: 5px;\n  justify-content: center;\n  align-items: center;\n}\n\n.content-list {\n  padding-left: 10px;\n  padding-right: 10px;\n  font-family: \"Google Sans Regular\";\n}\n\n@media (max-width: 768px) {\n  .degree-card {\n    flex-direction: column;\n  }\n\n  .body-header {\n    flex-direction: column;\n  }\n\n  .body-header-title {\n    width: 100%;\n  }\n\n  .body-header-duration {\n    padding: 0;\n    margin: 0;\n    width: 100%;\n  }\n\n  .duration {\n    padding: 0px;\n    margin: 0px;\n    float: left;\n  }\n\n  .card-title {\n    font-size: 20px;\n  }\n\n  .card-subtitle {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
